import { render, staticRenderFns } from "./train.vue?vue&type=template&id=b9f08c0a&scoped=true"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=b9f08c0a&prod&scoped=true&lang=css&external"
import style1 from "./train.vue?vue&type=style&index=1&id=b9f08c0a&prod&scoped=true&lang=css"
import style2 from "./train.vue?vue&type=style&index=2&id=b9f08c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f08c0a",
  null
  
)

export default component.exports